import { Link } from '@tanstack/react-router';

interface MilesLogoProps {
  size?: 'sm' | 'lg';
  linked?: boolean;
}

export function MilesLogo({ size = 'sm', linked = true }: MilesLogoProps) {
  const fontSize = size === 'lg' ? '3rem' : '1.125rem';
  const lineHeight = size === 'lg' ? 2 : 1;
  // Gap as a proportion of font size (consistent across sizes)
  const gap = size === 'lg' ? 6 : 3;

  const content = (
    <div className="inline-flex flex-col items-stretch" style={{ fontSize }}>
      <span className="font-extrabold text-white tracking-tight leading-none" style={{ fontSize }}>
        Miles
      </span>
      <div
        style={{
          marginTop: gap,
          height: lineHeight,
          background:
            'linear-gradient(90deg, transparent, #9B8565 30%, #A08060 50%, #9B8565 70%, transparent)',
        }}
      />
    </div>
  );

  if (!linked) return content;

  return (
    <Link to="/" className="no-underline">
      {content}
    </Link>
  );
}
